/* Thread types the API accepts (`projects/api/services/pieveThread/normalizePieveThreadType.service.js`). */
export const SUBJECT_SCOPED_THREAD_TYPES = Object.freeze(['workflow_step', 'workflow_test']);

export const MAIN_THREAD_TYPE_NOT_IN = Object.freeze(['schedule_run', 'trigger_run', ...SUBJECT_SCOPED_THREAD_TYPES]);

export const PIEVE_THREAD_TYPES = Object.freeze(['default', 'onboarding', 'schedule', 'schedule_run', 'trigger', 'trigger_run', 'workflow', 'workflow_requirements', ...SUBJECT_SCOPED_THREAD_TYPES]);

/* Thread types a person talks in, listed as conversations: requests, onboarding, and the conversations that build a schedule, trigger or workflow. Run shells and step threads stay out (their runs show in Automations). */
export const CONVERSATION_THREAD_TYPES = Object.freeze(['default', 'onboarding', 'schedule', 'trigger', 'workflow_requirements', 'workflow']);

/* Conversation types that build an automation, with the kind the list names. */
export const AUTOMATION_BUILDER_KIND_BY_THREAD_TYPE = Object.freeze({
  schedule: 'Schedule',
  trigger: 'Trigger',
  workflow_requirements: 'Workflow',
  workflow: 'Workflow'
});
